import type { Theme } from '../../types/theme';

export const bmwTheme: Theme = {
  id: 'bmw',
  name: 'BMW',
  description: 'Dark premium surfaces with precise German engineering aesthetic',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/bmw/DESIGN.md',
  visualKeywords: ['dark', 'blue accent', 'premium', 'German engineering', 'luxury'],
  colors: {
    background: '#000000',
    surface: '#0a0a0a',
    surfaceElevated: '#141414',
    textPrimary: '#ffffff',
    textSecondary: '#888888',
    textMuted: '#888888',
    border: '#1a1a1a',
    borderSubtle: '#242424',
    primary: '#1c69d1',
    primaryHover: '#2b78e0',
    primaryActive: '#004bb3',
    accent: '#1c69d1',
    onPrimary: '#ffffff',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'low',
    tone: 'premium',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
